import {
  Button,
  Card,
  Link,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useFormatMessage } from '../../../../../hooks';
import { useGetCompaniesOffers } from './hooks/useGetCompaniesOffers';
import { useStyles } from './hooks/useStyles';
import { useGetOffers } from './hooks/useGetOffers';
import { SHeadTableCell } from '../../../../../components/styledComponents/Tables';
import { thousands } from '../../../../../utils/utils';
import Preloader from '../../../../../components/other/Preloader/Preloader';
import TablePaginator from '../../../../../components/TablePaginator/TablePaginator';
import { useAccept } from './hooks/useAccept';

export function ModerationList() {
  const fm = useFormatMessage();
  const { classes } = useStyles();
  const [companyId, setCompanyId] = React.useState<number>(-1);
  const { fetchCompanies, loadingCompanies, companies } = useGetCompaniesOffers();
  const { fetchOffers, loadingOffers, offers, page } = useGetOffers();
  const { fetchAcceptIds, fetchAcceptList, loadingAccept, successAccept } = useAccept();

  const handleAcceptAll = () => {
    fetchAcceptList({
      page: 1,
      per_page: 99999,
      company_id: companyId === -1 ? undefined : companyId,
      status: 'moderation',
      new_status: 'active',
    });
  };

  const handleAcceptIds = (ids: string) => {
    fetchAcceptIds({
      ids,
      status: 'active',
    });
  };

  useEffect(() => {
    successAccept &&
      fetchOffers({
        page: 1,
        per_page: 20,
        company_id: companyId === -1 ? undefined : companyId,
        status: 'moderation',
      });
  }, [successAccept]);

  useEffect(() => {
    fetchCompanies('moderation');
  }, []);

  useEffect(() => {
    fetchOffers({
      page: 1,
      per_page: 20,
      company_id: companyId === -1 ? undefined : companyId,
      status: 'moderation',
    });
  }, [companyId]);

  return (
    <Card className={classes.card}>
      <TextField
        select
        margin='normal'
        label={fm('PROVIDER')}
        value={companyId || ''}
        onChange={e => setCompanyId(Number(e.target.value))}
        variant='outlined'
        className={classes.textField}
        disabled={loadingCompanies}
      >
        <MenuItem value={-1}>{fm('ACTIVITY.ALL')}</MenuItem>
        {companies.map(option => (
          <MenuItem key={option.id?.toString()} value={option.id?.toString() || ''}>
            {option.brand || option.name}
          </MenuItem>
        ))}
      </TextField>
      {loadingOffers || !offers ? (
        <Preloader />
      ) : (
        <>
          {offers.length > 0 ? (
            <>
              <div className={classes.tableContainer}>
                <Table aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <SHeadTableCell className={classes.rowItems}>
                        {fm('PRODUCT.ID')}
                      </SHeadTableCell>
                      {/* <SHeadTableCell className={classes.rowItems}>
                  {fm('CHANGE.ACTIVITY.STATUS')}
                </SHeadTableCell> */}
                      <SHeadTableCell className={classes.rowItems}>
                        {fm('PARTNUMBER')}
                      </SHeadTableCell>
                      <SHeadTableCell className={classes.rowItems}>
                        {fm('CASE')}
                      </SHeadTableCell>
                      <SHeadTableCell className={classes.rowItems}>
                        {fm('COUNT.PRICE')}
                      </SHeadTableCell>
                      <SHeadTableCell className={classes.rowItems}>
                        {fm('STOCK.QUANTITY')}
                      </SHeadTableCell>
                      <SHeadTableCell className={classes.rowItems}>
                        {fm('ORDER.QUANTITY')}
                      </SHeadTableCell>
                      <SHeadTableCell className={classes.rowItems}>
                        <Button
                          onClick={handleAcceptAll}
                          disabled={loadingAccept}
                          variant='contained'
                        >
                          {fm('ACCEPT.ALL')}
                        </Button>
                      </SHeadTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {offers?.map(offer => (
                      <TableRow key={offer.id}>
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          {offer.product_id ? (
                            <Link
                              component={RouterLink}
                              to={`/viewproduct/${offer.product_id}`}
                            >
                              {offer.product_id}
                            </Link>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        {/* <TableCell component='th' scope='row' className={classes.rowItems}>
                    -
                  </TableCell> */}
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          {offer.product?.sku ? (
                            <Link
                              component={RouterLink}
                              to={`/viewproduct/${offer.product_id}`}
                            >
                              {offer.product.sku}
                            </Link>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          {offer.product?.package || '-'}
                        </TableCell>
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          {offer.prices.map(i => (
                            <Typography fontSize={17}>
                              {`${i.amount} шт. - ${thousands(String(i.price))} р.`}
                            </Typography>
                          ))}
                        </TableCell>
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          {`${offer.stock_quantity} шт.`}
                        </TableCell>
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          {`${offer.order_quantity} шт. / ${offer.delivery_period} нед.`}
                        </TableCell>
                        <TableCell component='th' scope='row' className={classes.rowItems}>
                          <Button
                            onClick={() => handleAcceptIds(offer.id.toString())}
                            variant='contained'
                            disabled={loadingAccept}
                          >
                            {fm('ACCEPT')}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <div className={classes.containerPagination}>
                  <TablePaginator
                    page={page.page}
                    realPerPage={offers?.length}
                    perPage={page.perPage}
                    total={page.total}
                    fetchRows={(data: any) =>
                      fetchOffers({
                        page: data.page,
                        per_page: data.perPage,
                        company_id: companyId === -1 ? undefined : companyId,
                        status: 'moderation',
                      })
                    }
                    label={fm('OFFERS.PERPAFE')}
                  />
                </div>
              </div>
            </>
          ) : null}
        </>
      )}
    </Card>
  );
}
